module.exports = __webpack_public_path__ + "static/img/555.d7d666d9.png";